import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from '@mui/material';
import { useParams } from 'react-router-dom';

const WrongAnswersTable = () => {
  const { idEmployee, idCourse } = useParams();
  const [beforeRetakeData, setBeforeRetakeData] = useState([]);
  const [afterRetakeData, setAfterRetakeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [pageBefore, setPageBefore] = useState(0);
  const [rowsPerPageBefore, setRowsPerPageBefore] = useState(5);
  const [pageAfter, setPageAfter] = useState(0);
  const [rowsPerPageAfter, setRowsPerPageAfter] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://api.academy.eurekagroup.id/progress/${idEmployee}/${idCourse}`
        );
        if (!response.ok) throw new Error('Failed to fetch data');
        const data = await response.json();

        const mappedBeforeRetake = data[0]?.originalQuizAnswers.map((item, index) => ({
          question: item.question,
          yourAnswer: item.userAnswer.selected_answer,
          correctAnswer: item.correctAnswer,
          isCorrect: item.userAnswer.is_correct,
        }));

        const mappedAfterRetake = data[0]?.retakeQuizAnswers.map((item, index) => ({
          question: item.question,
          yourAnswer: item.userAnswer.selected_answer,
          correctAnswer: item.correctAnswer,
          isCorrect: item.userAnswer.is_correct,
        }));

        setBeforeRetakeData(mappedBeforeRetake || []);
        setAfterRetakeData(mappedAfterRetake || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [idEmployee, idCourse]);

  const handleChangePageBefore = (event, newPage) => setPageBefore(newPage);
  const handleChangeRowsPerPageBefore = (event) => {
    setRowsPerPageBefore(parseInt(event.target.value, 10));
    setPageBefore(0);
  };

  const handleChangePageAfter = (event, newPage) => setPageAfter(newPage);
  const handleChangeRowsPerPageAfter = (event) => {
    setRowsPerPageAfter(parseInt(event.target.value, 10));
    setPageAfter(0);
  };

  const renderTable = (data, page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, title) => (
    <Card style={{ marginBottom: '20px' }}>
      <CardHeader title={title} />
      <CardContent>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : (
          <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>No</TableCell>
                    <TableCell>Question</TableCell>
                    <TableCell>Your Answer</TableCell>
                    <TableCell>Correct Answer</TableCell>
                    <TableCell>Is Correct</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell>{row.question}</TableCell>
                      <TableCell>{row.yourAnswer}</TableCell>
                      <TableCell>{row.correctAnswer}</TableCell>
                      <TableCell style={{ color: row.isCorrect ? 'green' : 'red' }}>
                        {row.isCorrect ? 'Yes' : 'No'}
                        </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={data.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </CardContent>
    </Card>
  );

  return (
    <>
      {renderTable(beforeRetakeData, pageBefore, rowsPerPageBefore, handleChangePageBefore, handleChangeRowsPerPageBefore, 'Before Retake')}
      {afterRetakeData.length > 0 && renderTable(afterRetakeData, pageAfter, rowsPerPageAfter, handleChangePageAfter, handleChangeRowsPerPageAfter, 'After Retake')}
    </>
  );
};

export default WrongAnswersTable;
